export default __webpack_public_path__ + "static/media/SINEB.72fdfd93.png";